import React, { ComponentType, lazy, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from '../../../pages/shared/error/ErrorPage/ErrorPage';

const LazyLoad = <T extends ComponentType<any>>(
  importFunction: () => Promise<{ default: T }>,
) => {
  const Component = lazy(importFunction);

  // eslint-disable-next-line react/display-name
  return (props: React.ComponentProps<T>) => (
    <Suspense fallback={null}>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <Component {...props} />
      </ErrorBoundary>
    </Suspense>
  );
};

export default LazyLoad;
